export default __webpack_public_path__ + "static/media/login-bg.e890f150.webp";